module.exports = __webpack_public_path__ + "img/youzan.dddda0d1.jpeg";